import Vue from 'vue';
import { ActivePopupTypes } from '@/store/modules/popup/types';
var EditModes;
(function (EditModes) {
    EditModes["default"] = "default";
    EditModes["edit"] = "edit";
})(EditModes || (EditModes = {}));
export default Vue.extend({
    name: 'apiKeysEditAddress',
    props: {
        id: {
            type: Number,
            required: true
        },
        name: {
            type: String,
            required: true
        },
        apiKey: {
            type: String,
            required: true
        },
        itBuddyKey: {
            type: Boolean,
            default: false
        },
        permissions: {
            type: Object,
            required: true
        },
        ip_filter: {
            type: Boolean,
            required: true
        },
        ips: {
            type: Array,
            required: true
        },
        selected: {
            type: Boolean,
            required: true
        },
        copied: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            mode: EditModes.default,
            form: {
                valid: false,
                fields: {
                    name: {
                        value: '',
                        rules: [
                            (v) => Boolean(v) || this.$t('apiKeysPage.errors.required')
                        ]
                    }
                }
            },
            codeError: false
        };
    },
    watch: {
        'name'(v) {
            this.form.fields.name.value = v;
        }
    },
    methods: {
        closeEditKey() {
            const vm = this;
            vm.$emit('deselectAll');
        },
        doBeginEditName() {
            if (!this.itBuddyKey) {
                this.mode = EditModes.edit;
            }
        },
        cancelEditName() {
            const vm = this;
            vm.mode = EditModes.default;
            vm.form.fields.name.value = vm.name;
        },
        openBuddyDeleteModal() {
            const vm = this;
            this.$store.dispatch('popupModule/openPopup', {
                type: ActivePopupTypes.action,
                letDefaultClose: true,
                title: this.$t('popups.titles.deleteKey'),
                slot: {
                    name: 'buddyDeletePopupChunk',
                    on: {
                        onDelete() {
                            vm.$emit('onClickDelete', { keyName: vm.form.fields.name.value, id: vm.id });
                        }
                    }
                }
            });
        },
        onClickDelete() {
            if (this.itBuddyKey) {
                this.openBuddyDeleteModal();
            }
            else {
                this.$emit('onClickDelete', { keyName: this.form.fields.name.value, id: this.id });
            }
        }
    },
    created() {
        const vm = this;
        if (vm.name) {
            vm.form.fields.name.value = vm.name;
        }
    }
});
